<template>
  <div class="plans">
    <div class="tway-title-hero"></div>
    <div class="announcement">
      <v-container class="text-center" align="center">
        <div
          class="josefin tway-morado--text mx-auto"
          style="font-size: 35px; line-height: 40px"
        >
          Acelera la transformación digital de tu empresa
        </div>
        <v-row class="mt-5" justify="center">
          <v-col cols="12">
            <v-btn
              rounded
              elevation="0"
              @click="clientType = false"
              :class="clientType ? 'btn mr-5' : 'btnSelected'"
              outlined
            >
              cliente
            </v-btn>
            <v-btn
              rounded
              elevation="0"
              @click="clientType = true"
              :class="!clientType ? 'btn ml-5' : 'btnSelected'"
              outlined
              width="130px"
              >especialista</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="desktop" class="mt-5">
          <v-col>
            <v-simple-table class="table1 w-100">
              <thead>
                <tr>
                  <th>
                    <v-container style="max-width: 400px">
                      <v-row justify="center">
                        <v-col cols="12">
                          <span class="cstitle"
                            >Selecciona el tamaño de tu empresa</span
                          >
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            return-object
                            :items="companySizeDetails"
                            item-text="size"
                            item-color="#7319d5"
                            v-model="selectedSize"
                            filled
                            rounded
                            color="#7319d5"
                            outlined
                          >
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </th>
                  <th>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <span class="planName"> Starter </span>
                        </v-col>
                        <v-col cols="12" class="mt-n5" :class="clientType ? 'clientSubtitleContent' : 'subtitleContents'">
                          <span class="subtitle">
                            {{
                              clientType
                                ? "Sé parte del catálogo y sin comisión por venta"
                                : "Obtén el diagnóstico Tway y tu plan de trabajo"
                            }}
                          </span>
                        </v-col>
                        <v-col cols="12" class="mt-3 contextCostText">
                          <span class="costText">
                            USD
                            {{
                              clientType
                                ? selectedSize.plans[0].costE
                                : selectedSize.plans[0].costC
                            }}
                          </span>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <span class="costSubtitle"> Paga una sola vez </span>
                        </v-col>
                        <v-col align="center">
                          <a
                            href="https://app.twaydigital.com/login"
                            target="blank"
                          >
                            <v-btn
                              rounded
                              elevation="0"
                              class="btnPlanSelection"
                              outlined
                              width="100%"
                              >Comienza</v-btn
                            >
                          </a>
                        </v-col>
                        <v-col cols="12" class="mt-n3">
                          <span class="subtitle">
                            {{
                              clientType
                                ? selectedSize.users.specialist
                                : selectedSize.users.client
                            }}
                            usuarios
                          </span>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <span
                            class="subtitle"
                            style="display: inline-block; margin-right: 5px"
                          >
                            {{
                              selectedSize.size == "Grande"
                                ? "Hasta " + selectedSize.diagnoses.client
                                : selectedSize.diagnoses.specialist
                            }}
                            diagnosticos
                          </span>
                        </v-col>
                      </v-row>
                    </v-container>
                  </th>
                  <th v-if="clientType == true">
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <span class="planName"> Manager </span>
                        </v-col>
                        <v-col cols="12" class="mt-n5 clientSubtitleContent">
                          <span class="subtitle">
                            Gestiona la transformación digital para tus clientes
                            con diagnósticos, reportes y planes de trabajo a la
                            medida.
                          </span>
                        </v-col>
                        <v-col cols="12" class="mt-3 contextCostText">
                          <span class="costText">
                            USD
                            {{
                              clientType
                                ? selectedSize.plans[1].costE
                                : selectedSize.plans[1].costC
                            }}
                          </span>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <span class="costSubtitle"> Paga una sola vez </span>
                        </v-col>
                        <v-col align="center"
                          ><a
                            href="https://app.twaydigital.com/login"
                            target="blank"
                          >
                            <v-btn
                              rounded
                              elevation="0"
                              class="btnPlanSelection"
                              outlined
                              width="100%"
                              >Comienza</v-btn
                            >
                          </a>
                        </v-col>
                        <v-col cols="12" class="mt-n3">
                          <span class="subtitle">
                            {{
                              clientType
                                ? selectedSize.users.specialist
                                : selectedSize.users.client
                            }}
                            usuarios
                          </span>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <span
                            class="subtitle"
                            style="display: inline-block; margin-right: 5px"
                          >
                            {{
                              selectedSize.size == "Grande"
                                ? "Hasta " + selectedSize.diagnoses.client
                                : selectedSize.diagnoses.specialist
                            }}
                            diagnosticos
                          </span>
                        </v-col>
                      </v-row>
                    </v-container>
                  </th>
                  <th>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <span class="planName"> Smart </span>
                        </v-col>
                        <v-col cols="12" class="mt-n5" :class="clientType ? 'clientSubtitleContent' : 'subtitleContents'">
                          <span class="subtitle">
                            Transformación Estratégica Starter + Manager
                          </span>
                          <span v-if="!clientType" class="subtitle"
                            >+ <b>Recalibración anual</b></span
                          >
                        </v-col>
                        <v-col cols="12" class="mt-3 contextCostText">
                          <span class="costText">
                            USD
                            {{
                              Math.round(
                                (clientType
                                  ? selectedSize.plans[2].costE
                                  : selectedSize.plans[2].costC) / 12
                              )
                            }}
                          </span>
                          <span class="subtitle">/pago mensual</span>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <span class="costSubtitle"> Suscripción anual </span>
                        </v-col>
                        <v-col align="center"
                          ><a
                            href="https://app.twaydigital.com/login"
                            target="blank"
                          >
                            <v-btn
                              rounded
                              elevation="0"
                              class="btnPlanSelection"
                              outlined
                              width="100%"
                              >Comienza</v-btn
                            >
                          </a>
                        </v-col>
                        <v-col cols="12" class="mt-n3">
                          <span class="subtitle">
                            {{
                              clientType
                                ? selectedSize.users.specialist
                                : selectedSize.users.client
                            }}
                            usuarios
                          </span>
                        </v-col>
                        <v-col cols="12" class="mt-n5">
                          <span
                            class="subtitle"
                            style="display: inline-block; margin-right: 5px"
                          >
                            {{
                              selectedSize.size == "Grande"
                                ? "Hasta " + selectedSize.diagnoses.client
                                : selectedSize.diagnoses.specialist
                            }}
                            diagnosticos
                          </span>
                        </v-col>
                      </v-row>
                    </v-container>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="clientType">
                  <td>
                    <v-container>
                      <v-row class="text-start" align="center">
                        <v-col cols="10"
                          ><span class="col1">
                            Catálogo de proveedores especializados
                          </span></v-col
                        >
                        <v-col cols="2"
                          ><v-tooltip bottom max-width="21em">
                            <template v-slot:activator="{ attrs, on }">
                              <v-img
                                style="display: inline-block"
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span class="text-center"
                              >Ranking exclusivo de proveedores de servicios,
                              productos y herramientas para la transformación
                              digital
                            </span>
                          </v-tooltip></v-col
                        >
                      </v-row>
                    </v-container>
                  </td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                  <td v-if="clientType == true"></td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-container>
                      <v-row class="text-start" align="center">
                        <v-col cols="10"
                          ><span class="col1">
                            {{
                              clientType
                                ? "Contenidos y Tendencias"
                                : "Diagnósticos Transformación Digital"
                            }}
                          </span></v-col
                        >
                        <v-col cols="2"
                          ><v-tooltip bottom max-width="21em">
                            <template v-slot:activator="{ attrs, on }">
                              <v-img
                                style="display: inline-block"
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span class="text-center"
                              >{{
                                clientType
                                  ? "Lo último en información sobre Transformación Digital"
                                  : " Resultado de la encuesta de madurez digital, que muestra el Índice de Madurez en Transformación Digital Tway y su análisis por dimensión "
                              }}
                            </span>
                          </v-tooltip></v-col
                        >
                      </v-row>
                    </v-container>
                  </td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                  <td v-if="clientType == true"></td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-container>
                      <v-row class="text-start" align="center">
                        <v-col cols="10"
                          ><span class="col1">
                            {{
                              clientType
                                ? "Benchmark online"
                                : "Plan de Trabajo a la medida"
                            }}
                          </span></v-col
                        >
                        <v-col cols="2"
                          ><v-tooltip bottom max-width="21em">
                            <template v-slot:activator="{ attrs, on }">
                              <v-img
                                style="display: inline-block"
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span class="text-center"
                              >{{
                                clientType
                                  ? "Posición de tu empresa y otras según las propuestas de valor en Tway"
                                  : " Hoja de ruta con recomendaciones y soluciones para abordar la transformación paso a paso "
                              }}
                            </span>
                          </v-tooltip></v-col
                        >
                      </v-row>
                    </v-container>
                  </td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                  <td v-if="clientType == true"></td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-container>
                      <v-row class="text-start" align="center">
                        <v-col cols="10"
                          ><span class="col1">
                            {{
                              clientType
                                ? "Monitoreo Virtual Transformación Digital"
                                : "Contenidos y Tendencias"
                            }}
                          </span></v-col
                        >
                        <v-col cols="2"
                          ><v-tooltip bottom max-width="21em">
                            <template v-slot:activator="{ attrs, on }">
                              <v-img
                                style="display: inline-block"
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span class="text-center"
                              >{{
                                clientType
                                  ? "Seguimiento y medición de impacto de las iniciativas de transformación digital y su impacto en indicadores de con un asistente virtual especializado"
                                  : "Lo último en información sobre Transformación Digital "
                              }}
                            </span>
                          </v-tooltip></v-col
                        >
                      </v-row>
                    </v-container>
                  </td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                  <td v-if="clientType == true"></td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-container>
                      <v-row class="text-start" align="center">
                        <v-col cols="10"
                          ><span class="col1">
                            {{
                              clientType
                                ? "Diagnósticos Transformación Digital para clientes"
                                : "Catálogo de proveedores especializados"
                            }}
                          </span></v-col
                        >
                        <v-col cols="2"
                          ><v-tooltip bottom max-width="21em">
                            <template v-slot:activator="{ attrs, on }">
                              <v-img
                                style="display: inline-block"
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span class="text-center"
                              >{{
                                clientType
                                  ? "Resultado de la encuesta de madurez digital, que muestra el Índice de Madurez en Transformación Digital Tway y su análisis por dimensión"
                                  : "Ranking exclusivo de proveedores de servicios, productos y herramientas para la transformación digital"
                              }}
                            </span>
                          </v-tooltip></v-col
                        >
                      </v-row>
                    </v-container>
                  </td>
                  <td></td>
                  <td v-if="clientType == true">
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-container>
                      <v-row class="text-start" align="center">
                        <v-col cols="10"
                          ><span class="col1">
                            {{
                              clientType
                                ? "Plan de Trabajo para clientes"
                                : "Licitación de proyectos"
                            }}
                          </span></v-col
                        >
                        <v-col cols="2"
                          ><v-tooltip bottom max-width="21em">
                            <template v-slot:activator="{ attrs, on }">
                              <v-img
                                style="display: inline-block"
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span class="text-center"
                              >{{
                                clientType
                                  ? "Hoja de ruta con recomendaciones y soluciones para abordar la transformación paso a paso"
                                  : "Proceso participativo para obtener la adquisición de servicios en transformación digital"
                              }}
                            </span>
                          </v-tooltip></v-col
                        >
                      </v-row>
                    </v-container>
                  </td>
                  <td></td>
                  <td v-if="clientType == true">
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-container>
                      <v-row class="text-start" align="center">
                        <v-col cols="10"
                          ><span class="col1">
                            {{
                              clientType
                                ? "Dashboard Gestión cartera clientes"
                                : "Monitoreo Virtual Transformación Digital"
                            }}
                          </span></v-col
                        >
                        <v-col cols="2"
                          ><v-tooltip bottom max-width="21em">
                            <template v-slot:activator="{ attrs, on }">
                              <v-img
                                style="display: inline-block"
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span class="text-center"
                              >{{
                                clientType
                                  ? "Panel dinámico desde donde podrás administrar y monitorear invitaciones a realizar el diagnóstico y la gestión de la transformación digital de tu cartera de clientes disponible 24/7"
                                  : "Seguimiento y medición de impacto de las iniciativas de transformación digital y su impacto en indicadores de con un asistente virtual especializado"
                              }}
                            </span>
                          </v-tooltip></v-col
                        >
                      </v-row>
                    </v-container>
                  </td>
                  <td></td>
                  <td v-if="clientType == true">
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-container>
                      <v-row class="text-start" align="center">
                        <v-col cols="10"
                          ><span class="col1">
                            {{
                              clientType
                                ? "Reportes"
                                : "Recalibración anual diagnóstico de Transformación Digital"
                            }}
                          </span></v-col
                        >
                        <v-col cols="2"
                          ><v-tooltip bottom max-width="21em">
                            <template v-slot:activator="{ attrs, on }">
                              <v-img
                                style="display: inline-block"
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <span class="text-center">
                              {{
                                clientType
                                  ? "Acceso al catálogo de proveedores después del levantamiento de un proyecto"
                                  : "Reevaluación de la Transformación Digital de tu empresa al cumplirse un año de permanencia en Tway"
                              }}</span
                            >
                          </v-tooltip></v-col
                        >
                      </v-row>
                    </v-container>
                  </td>
                  <td></td>
                  <td v-if="clientType == true">
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                  <td>
                    <v-icon color="#119A24"> mdi-check </v-icon>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row v-if="mobile" class="ma-0 mobile" justify="center">
          <v-col cols="12">
            <span class="cstitle">Selecciona el tamaño de tu empresa</span
            >
          </v-col>
          <v-col cols="12">
            <v-select
              return-object
              :items="companySizeDetails"
              item-text="size"
              item-color="#7319d5"
              v-model="selectedSize"
              filled
              rounded
              color="#7319d5"
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="12" class="px-0">
            <v-card
              elevation="3"
              min-height="600px"
              class="pa-5 plan-card card-outter flex d-flex flex-column mx-2"
            >
              <v-carousel v-model="carouselPosition" hide-delimiter-background :show-arrows="false" height="600px">
                <v-carousel-item :dark="$vuetify.theme.dark" :light="!$vuetify.theme.dark">
                  <v-card-text>
                    <v-row
                      class="text-h5 text--tway-violet pb-3 font-weight-bold"
                      justify="start"
                    >
                      <div class="planName">Starter</div>
                    </v-row>
                    <v-row class="text-h5 font-weight-bold roboto contextCostText" justify="start">
                      <v-col cols="12" class="costText px-0 pb-0 pt-2" align="left">
                        USD
                        {{
                          clientType
                            ? selectedSize.plans[0].costE
                            : selectedSize.plans[0].costC
                        }}
                        <span class="subtitle-2 roboto" style="align-self: end">
                          / cobro mensual
                        </span>
                      </v-col>
                    </v-row>
                    <v-row
                      class="subtitle-2 mb-4 roboto font-wight-bold"
                      justify="start"
                    >
                      <strong>
                        <span class="costSubtitle">Paga una sola vez</span>
                      </strong>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="mt-n1 pl-0 py-1 d-flex justify-start">
                        <span class="text-t roboto">
                          {{
                            clientType
                              ? selectedSize.users.specialist
                              : selectedSize.users.client
                          }} 
                          usuarios
                        </span>
                      </v-col>
                      <v-col cols="12" class="mt-n1 pl-0 py-1 d-flex justify-start">
                        <span class="text-t roboto">
                          {{
                            selectedSize.size == "Grande"
                              ? "Hasta " + selectedSize.diagnoses.client
                              : selectedSize.diagnoses.specialist
                          }}
                          diagnosticos
                        </span>
                      </v-col>
                    </v-row>

                    <v-row class="my-5">
                        <v-btn
                          rounded
                          block
                          color="success"
                          class="roboto "
                          href="https://app.twaydigital.com/login"
                          target="blank"
                        >
                          Seleccionar
                        </v-btn>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row class="mt-4">
                      <div class="text--primary mx-n5 pl-5">
                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: flex-start;
                          "
                          class="mb-1"
                          v-for="(feature, featureIndex) in getFeatures.starter"
                          :key="featureIndex"
                        >
                          <v-img
                            :src="require('@/assets/img/check-2.svg')"
                            class="rounded mr-2"
                            min-width="12px"
                            max-width="12px"
                            style="align-self: center"
                          />
                          <span
                            v-html="feature"
                            class="text-t roboto pr-2 text-left"
                          />
                        </div>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-carousel-item>
                <v-carousel-item v-if="clientType" :dark="$vuetify.theme.dark" :light="!$vuetify.theme.dark">
                  <v-card-text>
                    <v-row
                      class="text-h5 text--tway-violet pb-3 font-weight-bold"
                      justify="start"
                    >
                      <div class="planName">Manager</div>
                    </v-row>
                    <v-row class="text-h5 font-weight-bold roboto contextCostText" justify="start">
                      <v-col cols="12" class="costText px-0 pb-0 pt-2" align="left">
                        USD
                        {{
                          clientType
                            ? Math.round(selectedSize.plans[1].costE / 12)
                            : Math.round(selectedSize.plans[1].costC / 12)
                        }}
                        <span class="subtitle-2 roboto" style="align-self: end">
                          / cobro mensual
                        </span>
                      </v-col>
                      <v-col cols="12" class="pa-0" align="left">
                        <strong class="subtitle-1 font-weight-bold roboto">
                          USD
                          {{
                          clientType
                            ? selectedSize.plans[1].costE
                            : selectedSize.plans[1].costC
                        }}
                        </strong>
                        <span class="subtitle-2" style="align-self: end">
                          total anual
                        </span>
                      </v-col>
                    </v-row>
                    <v-row
                      class="subtitle-2 mb-4 roboto font-wight-bold"
                      justify="start"
                    >
                      <strong>
                        <span class="costSubtitle">Suscripción anual</span>
                      </strong>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="mt-n1 pl-0 py-1 d-flex justify-start">
                        <span class="text-t roboto">
                          {{
                            clientType
                              ? selectedSize.users.specialist
                              : selectedSize.users.client
                          }} 
                          usuarios
                        </span>
                      </v-col>
                      <v-col cols="12" class="mt-n1 pl-0 py-1 d-flex justify-start">
                        <span class="text-t roboto">
                          {{
                            selectedSize.size == "Grande"
                              ? "Hasta " + selectedSize.diagnoses.client
                              : selectedSize.diagnoses.specialist
                          }}
                          diagnosticos
                        </span>
                      </v-col>
                    </v-row>

                    <v-row class="my-5">
                      <v-btn
                        rounded
                        block
                        color="success"
                        class="roboto btnPlanSelection"
                        width="100%"
                        href="https://app.twaydigital.com/login"
                        target="blank"
                      >
                        Seleccionar
                      </v-btn>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row class="mt-4">
                      <div class="text--primary mx-n5 pl-5">
                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: flex-start;
                          "
                          class="mb-1"
                          v-for="(feature, featureIndex) in getFeatures.manager"
                          :key="featureIndex"
                        >
                          <v-img
                            :src="require('@/assets/img/check-2.svg')"
                            class="rounded mr-2"
                            min-width="12px"
                            max-width="12px"
                            style="align-self: center"
                          />
                          <span
                            v-html="feature"
                            class="text-t roboto pr-2 text-left"
                          />
                        </div>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-carousel-item>
                <v-carousel-item :dark="$vuetify.theme.dark" :light="!$vuetify.theme.dark">
                  <v-card-text>
                    <v-row
                      class="text-h5 text--tway-violet pb-3 font-weight-bold"
                      justify="start"
                    >
                      <div class="planName">Smart</div>
                    </v-row>
                    <v-row class="text-h5 font-weight-bold roboto contextCostText" justify="start">
                      <v-col cols="12" class="costText px-0 pb-0 pt-2" align="left">
                        USD
                        {{
                          clientType
                            ? Math.round(selectedSize.plans[2].costE / 12)
                            : Math.round(selectedSize.plans[2].costC / 12)
                        }}
                        <span class="subtitle-2 roboto" style="align-self: end">
                          / cobro mensual
                        </span>
                      </v-col>
                      <v-col cols="12" class="pa-0" align="left">
                        <strong class="subtitle-1 font-weight-bold roboto">
                          USD
                          {{
                          clientType
                            ? selectedSize.plans[2].costE
                            : selectedSize.plans[2].costC
                        }}
                        </strong>
                        <span class="subtitle-2 roboto" style="align-self: end">
                          total anual
                        </span>
                      </v-col>
                    </v-row>
                    <v-row
                      class="subtitle-2 mb-4 roboto font-wight-bold"
                      justify="start"
                    >
                      <strong>
                        <span class="costSubtitle">Suscripción anual</span>
                      </strong>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="mt-n1 pl-0 py-1 d-flex justify-start">
                        <span class="text-t roboto">
                          {{
                            clientType
                              ? selectedSize.users.specialist
                              : selectedSize.users.client
                          }} 
                          usuarios
                        </span>
                      </v-col>
                      <v-col cols="12" class="mt-n1 pl-0 py-1 d-flex justify-start">
                        <span class="text-t roboto">
                          {{
                            selectedSize.size == "Grande"
                              ? "Hasta " + selectedSize.diagnoses.client
                              : selectedSize.diagnoses.specialist
                          }}
                          diagnosticos
                        </span>
                      </v-col>
                    </v-row>

                    <v-row class="my-5">
                      <v-btn
                        rounded
                        block
                        color="success"
                        class="roboto btnPlanSelection"
                        width="100%"
                        href="https://app.twaydigital.com/login"
                        target="blank"
                      >
                        Seleccionar
                      </v-btn>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row class="mt-4">
                      <div class="text--primary mx-n5 pl-5">
                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: flex-start;
                          "
                          class="mb-1"
                          v-for="(feature, featureIndex) in getFeatures.smart"
                          :key="featureIndex"
                        >
                          <v-img
                            :src="require('@/assets/img/check-2.svg')"
                            class="rounded mr-2"
                            min-width="12px"
                            max-width="12px"
                            style="align-self: center"
                          />
                          <span
                            v-html="feature"
                            class="text-t roboto pr-2 text-left"
                          />
                        </div>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-carousel-item>
              </v-carousel>
              <div
                @click="carouselPosition--"
                class="v-window__prev"
                style="
                  left: -30px;
                  border-top-left-radius: none;
                  border-top-right-radius: none;
                "
              >
                <button
                  type="button"
                  class="v-btn v-btn--icon v-btn--round v-size--default"
                >
                  <span class="v-btn__content">
                    <i
                      aria-hidden="true"
                      class="v-icon notranslate mdi mdi-chevron-left white--text"
                      style="font-size: 36px"
                    >
                    </i>
                  </span>
                </button>
              </div>
              <div
                @click="carouselPosition++"
                class="v-window__next"
                style="
                  right: -30px;
                  border-top-left-radius: none;
                  border-top-right-radius: none;
                "
              >
                <button
                  type="button"
                  class="v-btn v-btn--icon v-btn--round v-size--default"
                  aria-label="Visual siguiente"
                >
                  <span class="v-btn__content">
                    <i
                      aria-hidden="true"
                      class="v-icon notranslate mdi mdi-chevron-right white--text"
                      style="font-size: 36px"
                    >
                    </i>
                  </span>
                </button>
              </div>
              <div></div>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col>
            <span class="subtitle1">Revisa todos los valores</span>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col
            align="end"
            cols="5"
            :class="
              !clientType ? 'mt-5 swichSelected' : 'mt-5 swichNotSelected'
            "
            ><span>Cliente</span></v-col
          >
          <v-col cols="2" sm="2" md="1" lg="1" xl="1">
            <div class="d-flex justify-center align-center">
              <v-switch inset v-model="clientType" success></v-switch>
            </div>
          </v-col>
          <v-col
            align="start"
            cols="5"
            :class="clientType ? 'mt-5 swichSelected' : 'mt-5 swichNotSelected'"
            ><span>Especialista</span></v-col
          >
        </v-row>
        <v-row justify="center">
          <v-col cols="12" align="center">
            <v-simple-table class="table2 w-100">
              <tr class="headers">
                <th>
                  <v-row justify="center">
                    <v-col align="center">
                      <span class="mr-2">Empresas</span>
                    </v-col>
                  </v-row>
                </th>
                <th>
                  <v-row justify="center">
                    <v-col align="center">
                      <span class="mr-2">Plan Starter</span>
                    </v-col>
                  </v-row>
                </th>
                <th :class="!clientType ? 'd-none' : ''">
                  <v-row justify="center">
                    <v-col align="center">
                      <span class="mr-2">Plan Manager</span>
                    </v-col>
                  </v-row>
                </th>
                <th>
                  <v-row justify="center">
                    <v-col align="center">
                      <span class="mr-2">Plan Smart</span>
                    </v-col>
                  </v-row>
                </th>
                <th>
                  <v-row justify="center">
                    <v-col align="center">
                      <span class="mr-2">Usuarios</span>
                      <v-tooltip bottom max-width="21em">
                        <template v-slot:activator="{ attrs, on }">
                          <v-img
                            style="display: inline-block"
                            :src="
                              require('@/assets/img/carbon_information.png')
                            "
                            height="15px"
                            width="15px"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <span class="text-center"
                          >Persona que usa la plataforma para una o varias
                          funciones (administra, invita a hacer encuesta,
                          licita, gestiona proyectos, etc.)</span
                        >
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </th>
                <th>
                  <v-row justify="center">
                    <v-col align="center">
                      <span class="mr-2">Diagnósticos</span>
                      <v-tooltip bottom max-width="21em">
                        <template v-slot:activator="{ attrs, on }">
                          <v-img
                            style="display: inline-block"
                            :src="
                              require('@/assets/img/carbon_information.png')
                            "
                            height="15px"
                            width="15px"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <span class="text-center"
                          >Invitaciones disponibles para realizar la encuesta de
                          madurez digital Tway
                        </span>
                      </v-tooltip></v-col
                    >
                  </v-row>
                </th>
                <th>
                  <v-row justify="center">
                    <v-col align="center">
                      <span class="mr-2">Cuentas adicionales</span>
                      <v-tooltip bottom max-width="21em">
                        <template v-slot:activator="{ attrs, on }">
                          <v-img
                            style="display: inline-block"
                            :src="
                              require('@/assets/img/carbon_information.png')
                            "
                            height="15px"
                            width="15px"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <span class="text-center"
                          >Paquete de cuentas para sumar a las que ya tienes
                          contratadas
                        </span>
                      </v-tooltip></v-col
                    >
                  </v-row>
                </th>
              </tr>
              <tr v-for="(item, index) in companySizeDetails" :key="index">
                <td>
                  <v-container>{{ item.size }}</v-container>
                </td>
                <td>
                  <v-container
                    >USD
                    {{
                      clientType ? item.plans[0].costE : item.plans[0].costC
                    }}</v-container
                  >
                </td>
                <td :class="!clientType ? 'd-none' : '' ">
                  <v-container
                    >USD
                    {{
                      clientType ? item.plans[1].costE : item.plans[1].costC
                    }}</v-container
                  >
                </td>
                <td>
                  <v-container
                    >USD
                    {{
                      clientType ? item.plans[2].costE : item.plans[2].costC
                    }}</v-container
                  >
                </td>
                <td>
                  <v-container>{{
                    clientType ? item.users.specialist : item.users.client
                  }}</v-container>
                </td>
                <td>
                  {{
                    index == 3
                      ? "hasta " + item.diagnoses.specialist
                      : item.diagnoses.client
                  }}
                </td>
                <td rowspan="4" v-if="index == 0">
                  <v-row justify="center">
                    <v-col align="center">
                      Cada 5 diagnósticos adicionales por USD 100
                    </v-col>
                  </v-row>
                </td>
              </tr>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col>
            <span class="subtitle1">Preguntas Frecuentes</span>
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span>¿Cómo comenzar?</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Si eres Cliente o Especialista, debes dirigirte a
                    <a
                      href="https://www.twaydigital.com"
                      style="color:#7319d5"
                      target="blank"
                      >www.twaydigital.com</a
                    >, y hacer clic en el botón ‘Regístrate gratis’, donde
                    crearás una cuenta con algunos datos de la empresa y tras
                    recibir la confirmación de tu correo podrás activar tu
                    cuenta.
                  </p>
                  <p>
                    Con tu usuario y contraseña confirmado podrás acceder a la
                    plataforma Tway y en la pestaña "Mi Plan", podrás seguir los
                    pasos para contratar el plan que tu empresa necesita para
                    activar su transformación digital.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span>Si soy Cliente ¿Cómo contrato Starter?</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Una vez dentro de la plataforma Tway, en la pestaña "Mi
                    Plan", selecciona Starter y sigue los pasos de contratación.
                    Una vez contratado, podrás realizar la encuesta de madurez
                    digital para obtener el diagnóstico de transformación
                    digital de tu empresa con el Índice de Madurez en
                    Transformación Digital, el detalle de los resultados por
                    cada dimensión, acceso a tus desafíos estratégicos y plan de
                    trabajo en un dashboard disponible 24/7. Además, recibirás
                    una selección de los mejores contenidos y tendencias en
                    transformación digital. La modalidad de contratación se
                    efectúa en un único pago.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span>Si soy Especialista ¿Cómo contrato Starter?</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Una vez dentro de la plataforma Tway, en la pestaña "Mi
                    Plan", selecciona Starter y sigue los pasos de contratación.
                    Una vez contratado Starter, serás parte del catálogo de
                    proveedores especialistas de transformación digital de Tway
                    para participar de licitaciones, contar con un asistente
                    virtual para monitorear online los proyectos de
                    transformación. También accederás a un dashboard disponible
                    24/7 con información de benchmark de tu rubro, competencia y
                    más información de valor. Incluye una selección de los
                    mejores contenidos y tendencias en transformación digital.
                    La modalidad de contratación es de un solo pago.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span
                    >Soy Cliente y tengo contratado Starter, ¿Puedo adquirir la
                    suscripción de Manager?</span
                  >
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Como Cliente, podrás contratar el plan Manager únicamente si
                    ya cuentas con Starter. Para adquirir la suscripción del
                    plan Manager, ingresa a “Mi Plan” y sigue los pasos de la
                    compra que se te presentarán. Con Manager accederás al
                    dashboard con recomendaciones para reducir brechas, podrás
                    levantar proyectos para acelerar la transformación de tu
                    empresa, licitar, conectar con proveedores a la medida y
                    contar con el monitoreo online con asistente virtual. La
                    modalidad de pago es la suscripción anual con pagos
                    mensuales.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span
                    >Soy Especialista y tengo contratado Starter, ¿Puedo
                    adquirir Manager?</span
                  >
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Especialista, puedes adquirir el plan Manager sin depender
                    de si previamente contrataste Starter.
                  </p>
                  <p>
                    Para ello dirígete en la plataforma Tway a la sección "Mi
                    Plan", escoge la opción de contratar el plan Manager y sigue
                    los pasos que se te presentarán. La modalidad de
                    contratación es de un solo pago.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span
                    >Soy Especialista y no tengo contratado Starter, ¿Puedo
                    adquirir Manager?</span
                  >
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Puedes adquirir Manager, ya que para el usuario Especialista
                    Starter y Manager no tienen dependencia. Para ello dirígete
                    en la plataforma Tway a la sección "Mi Plan", escoge la
                    opción de contratar el plan Manager y sigue los pasos que se
                    te presentarán. La modalidad de contratación es de un solo
                    pago.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span>¿Cómo contrato Smart?</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Una vez dentro de la plataforma Tway, en la pestaña "Mi
                    Plan", selecciona el plan Smart y sigue los pasos de
                    contratación. Una vez contratado Smart, podrás acceder a la
                    totalidad de los beneficios como Cliente o Especialista y
                    además exclusivamente con el plan Smart podrás ejecutar la
                    recalibración anual del Indice de transformación digital
                    para tu empresa.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span>¿Qué significa la Recalibración anual?</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Este beneficio consiste en una reevaluación del Indice de
                    transformación digital para medir el progreso de la
                    Transformación Digital de tu empresa, una vez transcurrido
                    un año, con el objetivo de detectar nuevos planes de trabajo
                    para seguir reduciendo las brechas digitales. Sólo se
                    encuentra disponible para Clientes o Especialistas que
                    contraten el Plan Smart.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="headersExpansion">
                  <span>¿Cuántas cuentas adicionales puedo contratar?</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="text-start contentExpansion">
                  <p>
                    Podrás comprar paquetes de hasta 5 cuentas por vez, con la
                    frecuencia que tú definas y tantas veces como lo requieras.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script scoped>
  export default {
    data() {
      return {
        clientType: false,
        switchClientType: false,
        carouselPosition: 0,
        selectedSize: {
          size: "MYPE",
          plans: [
            { planName: "Starter", costC: "250", costE: "250" },
            { planName: "Manager", costC: "750", costE: "1000" },
            { planName: "Smart", costC: "1000", costE: "1250" },
          ],
          users: { client: 3, specialist: 3 },
          diagnoses: { client: 10, specialist: 10 },
        },
        companySizeDetails: [
          {
            size: "MYPE",
            plans: [
              { planName: "Starter", costC: "250", costE: "250" },
              { planName: "Manager", costC: "750", costE: "1000" },
              { planName: "Smart", costC: "1000", costE: "1250" },
            ],
            users: { client: 3, specialist: 3 },
            diagnoses: { client: 10, specialist: 10 },
          },
          {
            size: "PYME",
            plans: [
              { planName: "Starter", costC: "500", costE: "500" },
              { planName: "Manager", costC: "1500", costE: "2000" },
              { planName: "Smart", costC: "2000", costE: "2500" },
            ],
            users: { client: 5, specialist: 5 },
            diagnoses: { client: 50, specialist: 50 },
          },
          {
            size: "Mediana",
            plans: [
              { planName: "Starter", costC: "2500", costE: "2500" },
              { planName: "Manager", costC: "7500", costE: "10000" },
              { planName: "Smart", costC: "10000", costE: "12500" },
            ],
            users: { client: 15, specialist: 7 },
            diagnoses: { client: 250, specialist: 250 },
          },
          {
            size: "Grande",
            plans: [
              { planName: "Starter", costC: "5000", costE: "5000" },
              { planName: "Manager", costC: "15000", costE: "20000" },
              { planName: "Smart", costC: "20000", costE: "25000" },
            ],
            users: { client: 30, specialist: 10 },
            diagnoses: { client: 2000, specialist: 2000 },
          },
        ],
        features: {
          client: {
            starter: [
              "Diagnósticos Transformación Digital",
              "Plan de Trabajo a la medida",
              "Contenidos y Tendencias",
            ],
            smart: [
              "Diagnósticos Transformación Digital",
              "Plan de Trabajo a la medida",
              "Contenidos y Tendencias",
              "Catálogo de proveedores especializados",
              "Licitación de proyectos",
              "Monitoreo Virtual Transformación Digital",
              "Recalibración anual diagnóstico de Transformación Digital",
            ]
          },
          specialist: {
            starter: [
              "Catálogo de proveedores especializados",
              "Contenidos y Tendencias",
              "Benchmark online",
              "Monitoreo Virtual Transformación Digital",
            ],
            manager: [
              "Diagnósticos Transformación Digital para clientes",
              "Plan de Trabajo para clientes",
              "Dashboard Gestión cartera clientes",
              "Reportes"
            ],
            smart: [
              "Catálogo de proveedores especializados",
              "Contenidos y Tendencias",
              "Benchmark online",
              "Monitoreo Virtual Transformación Digital",
              "Diagnósticos Transformación Digital para clientes",
              "Plan de Trabajo para clientes",
              "Dashboard Gestión cartera clientes",
              "Reportes"
            ],
          }
        }
      };
    },
    methods: {},
    computed: {
      getFeatures() {
        if (this.clientType) {
          return this.features.specialist;
        }
        
        return this.features.client;
      },
      mobile() {
        return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
      },
      desktop() {
        return (
          this.$vuetify.breakpoint.md ||
          this.$vuetify.breakpoint.lg ||
          this.$vuetify.breakpoint.xl
        );
      },
    },
  };
</script>

<style>
  .announcement {
    padding-top: 50px;
  }
  .plans {
    margin-bottom: 100px;
  }
  .table1 {
    font-family: Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }
  .table1 td,
  .table1 th {
    border: 1px solid #ddd;
    padding: 8px;
  }
  .table2 {
    border-collapse: collapse;
    width: 100%;
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: #333333;
  }
  .table2 td,
  .table2 th {
    border: 1px solid #ddd;
    padding: 8px;
  }
  .table1 tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  .table2 tr:nth-child(odd) {
    background-color: #f2f2f2;
  }
  .table1 th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    width: 12%;
  }
  .table2 th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    width: 10%;
  }
  .btn {
    box-sizing: border-box;
    padding: 13px 20px;
    gap: 10px;
    border: 1px solid #7319d5;
    border-radius: 30px;
    color: #7319d5 !important;
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.08em;
  }
  .btnSelected {
    padding: 16px 25px;
    gap: 10px;
    background: #7319d5;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
    border-radius: 28px;
    color: white !important;
  }
  .cstitle {
    font-family: "Josefin Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: start;
    color: #7319d5;
  }
  .planName {
    font-family: "Josefin Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 25px;
    line-height: 25px;
    color: #7319d5;
  }
  .subtitle {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: #666666;
  }
  .costText {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 120%;
    color: #333333;
  }
  .costSubtitle {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
    color: #7319d5;
  }
  .btnPlanSelection {
    padding: 13px 20px;
    gap: 10px;
    width: 217.33px;
    height: 44px;
    background: #119a24;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #ffffff !important;
  }
  .col1 {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    color: #333333;
  }
  .subtitle1 {
    font-family: "Josefin Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 30px;
    color: #7319d5;
  }
  .headers {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
    color: #333333;
  }
  .headersExpansion {
    font-family: "Josefin Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    color: #333333;
  }
  .contentExpansion {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: #333333;
  }
  .swichSelected {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #333333;
  }
  .swichNotSelected {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #999999;
  }
  .v-carousel__controls .v-item-group .v-carousel__controls__item {
    color: #7c7c7c;
  }
  .v-carousel__controls .v-item-group .v-item--active {
    color: #119A24;
  }
  .v-carousel__controls .v-item-group .v-carousel__controls__item::before {
    color: #119A24;
  }
  @media (min-width: 1265px) and (max-width: 2560px) {
    .clientSubtitleContent {
      height: 80px;
    }
    .contextCostText {
      height: 79px;
    }
  }
  @media (min-width: 1025px) and (max-width: 1264px) {
    .clientSubtitleContent {
      height: 115px;
    }
  }
  @media (min-width: 704px) and (max-width: 1024px) {
    .clientSubtitleContent {
      height: 162px;
    }
    .subtitleContents {
      height: 85px;
    }
    .costText {
      font-size: 27px;
    }
    .contextCostText {
      height: 79px;
    }
  }
  @media (min-width: 1024px) {
    .subtitleContents {
      height: 50px;
    }
  }
</style>
